/**
 * Textarea — shadcn/ui primitive (native `<textarea>` styled with design tokens).
 *
 * Lifted from the binding mockup at
 * `reignara_redesign/components/ui/textarea.tsx` and adapted to import the
 * project's `cn()` utility from `@/lib/utils`. Class strings consume design
 * tokens via Tailwind utilities only; no hex / `rgb(` / `hsl(` literals
 * (Requirement 4.5).
 *
 * Feature: meridian-redesign
 * Requirements: 4.3, 4.4, 4.5
 */

import * as React from'react';

import { cn } from'@/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>): JSX.Element {
 return (
 <textarea
 data-slot="textarea"
 className={cn(
'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 :ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-input border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
 className,
 )}
 {...props}
 />
 );
}

export { Textarea };
